import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import "./index.css"
import store from "./store"
import SessionProvider from "context/sessionContext"
import AttendanceProvider from "context/attendanceContext"
import axios from "axios"

// Global axios interceptor to inject Authorization Bearer token if available
axios.interceptors.request.use(
  config => {
    let accessToken = localStorage.getItem("access_token")
    if (!accessToken) {
      const token = localStorage.getItem("Token")
      if (token) {
        try {
          accessToken = JSON.parse(token)
        } catch (e) {
          accessToken = token
        }
      }
    }
    if (accessToken) {
      config.headers = config.headers || {}
      const hasAuth = Object.keys(config.headers).some(
        key => key.toLowerCase() === "authorization"
      )
      if (!hasAuth) {
        config.headers["Authorization"] = `Bearer ${accessToken}`
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error)
  }
)

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <SessionProvider>
      <AttendanceProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AttendanceProvider>
    </SessionProvider>
  </Provider>
)
serviceWorkerRegistration.register()
